import type { FC } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'
import Badge from '@segment/matcha/components/Badge'
import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import PropCardBase, * as PropCard from '@segment/matcha/recipes/PropCard'

import { trackButtonClick } from '@segment/tracking/scripts'

import AIAnnouncementsWebp from './assets/AIAnnouncements.webp'
import AIAnnouncementsWebp2x from './assets/AIAnnouncements@2x.webp'
import AIAnnouncementsPng2x from './assets/AIAnnouncements@2x.png'

const copy = {
  badge: `Watch now`,
  heading: `Discover all the CustomerAI announcements from SIGNAL 2023`,
  description: `Hear from Twilio’s CEO on our latest CustomerAI product releases,  including more on the CustomerAI Personalization Engine and how he sees it changing customer engagement.`,
  button: {
    text: `Watch on demand`,
    url: `https://signal.twilio.com/2023/sign-in?rId=vs-1671250`,
  },
}

const AIAnnouncements: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <StyledSectionContents>
        <StyledPropCardBase reverse={true}>
          <PropCard.Img>
            <picture>
              <source type="image/webp" srcSet={`${AIAnnouncementsWebp}, ${AIAnnouncementsWebp2x} 2x`} />
              <Image
                src={AIAnnouncementsPng2x}
                alt="Illustration: Discover all the CustomerAI announcements from SIGNAL 2023"
                width="331"
                height="301"
                loading="lazy"
              />
            </picture>
          </PropCard.Img>
          <PropCard.Copy>
            <Badge variant="outlined">{copy.badge}</Badge>
            <PropCard.Title variant="h3" tag="h2">
              {copy.heading}
            </PropCard.Title>
            <PropCard.Text variant="pMedium">{copy.description}</PropCard.Text>
            <Button
              color="primary"
              href={copy.button.url}
              size="large"
              tag="a"
              variant="filled"
              onClick={() => trackButtonClick({ buttonText: copy.button.text, targetUrl: copy.button.url })}
            >
              {copy.button.text}
            </Button>
          </PropCard.Copy>
        </StyledPropCardBase>
      </StyledSectionContents>
    </SectionBase>
  )
}

export default AIAnnouncements

const StyledSectionContents = styled(Section.Contents)`
  max-width: 1040px;
  margin: 0 auto;
`

const StyledPropCardBase = styled(PropCardBase)`
  box-shadow: ${({ theme }) => theme.shadows[2]};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[3]};
  }
`
